import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ProductService } from '../../services/product.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { DataLayerService } from 'src/app/services/data-layer.service';
import { environment } from '../../../environments/environment';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { SesionService } from 'src/app/services/sesion.service';
import { BrokerService } from 'src/app/services/broker.service';
declare var $: any;

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit, AfterViewInit {

  linkDc = "https://buscacredito.midatacredito.com/ofertas?utm_source=MIDC&utm_medium=footer&utm_campaign=boton_bc";
  url_politica_privacidad = environment.urlPoliticaPrivacidad;
  url_terminos_condiciones = environment.urlTerminosYCondiciones;
  anio = new Date().getFullYear();
  public showDisclaimer = false;
  private bannerLoaded = false;

  get isLoggedIn(): boolean {
    return !!this.sesion.getCookie();
  }

  constructor(
    public content: ProductService,
    public sesion: SesionService,
    public broker: BrokerService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private utilities: UtilitiesService,
    private dlService: DataLayerService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (!this.isLoggedIn) {
      this.checkBannerMIDC();
    }
  }

  /**
   * Construye la URL de BuscaCredito con UTMs
   */
  get linkDcWithUtms(): string {
    return this.linkDc;
  }

  showBodylinks(ele: any) {
    var body = $($(".footer-links")[ele]).children(".body-links");
    var head = $($(".footer-links")[ele]).children(".head-links");
    if (body.css("display") == "none") {
      body.show();
      head.children("i").removeClass("fa-plus");
      head.children("i").addClass("fa-minus");
    } else {
      body.hide();
      head.children("i").removeClass("fa-minus");
      head.children("i").addClass("fa-plus");
    }
  }

  /**
   * Esta función envia un data layer de GA4 "clic_footer_menu" por cada opción que el usuario elija.
   * @param producto Variable en donde se almacena la opción seleccionada por el usuario.
   */
  clic_footer_menu(producto: string) {
    this.dlService.dl_eventoGA4_menu('clic_footer_menu', `${producto} | Footer`);
  }

  irServicioCliente() {
    this.router.navigate(['/servicio-cliente']);
  }

  checkRoutes() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (val.url == '' || val.url == '/' || val.url.includes('/?')) {
          this.showDisclaimer = true;
        } else {
          this.showDisclaimer = false;
        }
      }
    });
  }

  clic_footer_download_app() {
    this.dlService.dl_eventoGA4_general('clic_footer_download_app');
  }

  checkBannerMIDC() {
    if (this.bannerLoaded) { return; }
    this.bannerLoaded = true;
    const tamano = [[970, 250], [728, 250]];
    this.utilities.addPubliById(environment.slotsBanners.loginMIDC, 'div-gpt-ad-1694399862191-0', tamano);
  }
}
